import { render, staticRenderFns } from "./old-list.vue?vue&type=template&id=3f88ebed&scoped=true"
import script from "./old-list.vue?vue&type=script&lang=js"
export * from "./old-list.vue?vue&type=script&lang=js"
import style0 from "./old-list.vue?vue&type=style&index=0&id=3f88ebed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f88ebed",
  null
  
)

export default component.exports